import { c as _c } from "react/compiler-runtime";
import type * as React from 'react';

/**
 * Ambient backdrop adapted from the social podium halftone effect. A slowly
 * drifting dot-grid texture with three travelling brand/violet/cyan glows that
 * pulse and a brighter-dot spotlight that roams + breathes — all autonomous
 * (no cursor). Purely decorative: it sits behind the dashboard content at a
 * negative z within the page's stacking context. Animation is CSS-only
 * (`morfi-rewards-bg*` in globals.css) and pauses under `prefers-reduced-motion`.
 */
export function RewardsBackground() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div aria-hidden={true} className="morfi-rewards-bg pointer-events-none absolute inset-0 -z-10 overflow-hidden"><div className="morfi-rewards-bg__grid" /><div className="morfi-rewards-bg__glow morfi-rewards-bg__glow--a" /><div className="morfi-rewards-bg__glow morfi-rewards-bg__glow--b" /><div className="morfi-rewards-bg__glow morfi-rewards-bg__glow--c" /><div className="morfi-rewards-bg__spotlight" /></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}